import moment from 'moment';
import { DATE_FORMAT } from '../../constants'

export const createFilterUrl = (corporate) => {
    let url = new URLSearchParams();
    url.set('corporate', JSON.stringify(corporate));
    return decodeURIComponent(url)
}

export const getUrlFilter = (urlFilter) => {
    const params = new URLSearchParams(urlFilter);    
    const tempFilters = {
        corporate: params.get('corporate') ? JSON.parse(params.get('corporate')) : null
    };
    return tempFilters;
}

export const getSecondaryUrlFilter = (urlFilter) => {
    const params = new URLSearchParams(urlFilter);
    const tempFilters = {
        fromDate: params.get('dateRange') ? params.get('dateRange').split('to')[0] : null,
        toDate: params.get('dateRange') ? params.get('dateRange').split('to')[1] : null,
        productType: params.get('productType') ? { label: params.get('productType'), value: 'productType' } : undefined,
        caseType: params.get('caseType') ? { label: params.get('caseType'), value: 'caseType' } : undefined
    };
    return tempFilters
}

export const createSecondaryFilterUrl = (corporate, productType, caseType, date) => {
    let url = new URLSearchParams();
    url.set('corporate', JSON.stringify(corporate));
    if (productType) {
        url.set('productType', encodeURIComponent(productType.label));
    }
    if (caseType) {
        url.set('caseType', encodeURIComponent(caseType.label));
    }
    if (date && date.fromDate && date.toDate) {
        url.set("dateRange", encodeURIComponent(moment(date.fromDate).format(DATE_FORMAT) + 'to' + moment(date.toDate).format(DATE_FORMAT)));
    }
    return decodeURIComponent(url)
}

export const setAppliedFilters = (corporate, productType, caseType, data, date) => {
    let tempSelectedFilters = []

    if (corporate){
        tempSelectedFilters.push({ label: corporate.label, value: 'corporate' });
    }

    if (date && date.toDate && date.fromDate) {
        tempSelectedFilters.push({ label: (moment(date.fromDate).format(DATE_FORMAT) + ' to ' + moment(date.toDate).format(DATE_FORMAT)), value: 'date' })
    }
    if (productType) {
        tempSelectedFilters.push({ label: productType.label, value: 'productType' });
    }
    if (caseType) {
        tempSelectedFilters.push({ label: caseType.label, value: 'caseType' });
    }
    return tempSelectedFilters
}

export const setRequestBody = (corporate, productType, caseType, date) => {
    return {
        fromDate: (date && date.fromDate) ? moment(date.fromDate,"DD-MMM-YYYY").format("YYYY-MM-DD")+"T00:00:00+05:30" : null,
        toDate: (date && date.toDate) ? moment(date.toDate,"DD-MMM-YYYY").format("YYYY-MM-DD")+"T23:59:59+05:30" : null,
        counterpartyType: productType ? productType.label : null,
        country: caseType ? caseType.label : null,
        corporateId: corporate ? corporate.value : null
    }
}

export const deleteAppliedFilters = (removeFilter, appliedFilters) => {
    let tempAppliedFilters = [...appliedFilters];
    tempAppliedFilters.forEach((item, index, element) => {
        if (item.value === removeFilter.value) {
            appliedFilters.splice(index, 1)
        }
    })
    return appliedFilters;
}

export const deleteEntityFilter = (selectedEntity, removeFilter) => {
    let tempSelectedData = copyArray(selectedEntity);
    for (let i = 0; i < tempSelectedData.length; i++) {
        if (tempSelectedData[i].value === removeFilter.value) {
            tempSelectedData.splice(i, 1);
            break;
        }
    }
    return tempSelectedData;
}

export const copyArray = (data) => {
    let tempLevelOne = JSON.stringify(data);
    return JSON.parse(tempLevelOne)
}
